import { render, staticRenderFns } from "./changePhone.vue?vue&type=template&id=355e691a&scoped=true"
import script from "./changePhone.vue?vue&type=script&lang=js"
export * from "./changePhone.vue?vue&type=script&lang=js"
import style0 from "./changePhone.vue?vue&type=style&index=0&id=355e691a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355e691a",
  null
  
)

export default component.exports